import { useState } from 'react';
import { Wallet } from '../../styles/Layout'
import TableDevolve from './TableDevolve';
import { FlexContainer } from '../../styles/common/FlexBox';
import useCashbackData from '../../hooks/useCashbackData';
import { CashbackLogo } from './Styled';
import FeedbackModal from './Feedback';
const DevolveContainer = ({ userId }) => {

const { cashbackStatus, cashbacks } = useCashbackData({userId});
const [openModal, setOpenModal] = useState(false);
  return (
    <FlexContainer
      direction="column"
      justify="center"
      align="center"
      gap={60}
      style={{ width: '100%', fontWeight: 800, boxSizing: 'border-box' }}
    >
      <FlexContainer direction="column" justify="center" align="center" gap="20px">
        <CashbackLogo src="https://cdn.meucupom.com/app-assets/5.07.21/novomc/assets/images/cashback-logo.png" alt="" />
        <FlexContainer>
          Aqui você pode conferir o seu saldo e histórico de compras. 
          <a href="">Entenda como funciona clicando aqui.</a>
        </FlexContainer>
        
      </FlexContainer>
      <FlexContainer direction="column" justify="center" align="center" style={{gap: '25px'}}>
        <h2>
          Meu Saldo
        </h2>
        <FlexContainer
          justify="space-between"
          gap={70}
          mobileGap={40}
          style={{
            width: '100%',
            maxWidth: '750px',
            margin: '15px 0 0 0',
            flexWrap: 'nowrap',
            flexDirection: 'row',
            overflowX: 'auto'
          }}
        >
          <FlexContainer gap="10px"  style={{ flex: '1 1 0', minWidth: 0 }}>
            <Wallet src="https://static.meucupom.com/media/devolve/DEVOLVE-03.png" alt="" />
            <FlexContainer
              direction="column"
              justify="center"
              align="center"
            >
              <div style={{fontSize: '22px'}}>Pendente</div>
              <div style={{fontSize: '22px'}}>
                {cashbackStatus.pending}
              </div>
            </FlexContainer>
          </FlexContainer>
          
          <FlexContainer gap="10px">
            <Wallet src="https://static.meucupom.com/media/devolve/DEVOLVE-02.png" alt="" />
            <FlexContainer
              direction="column"
              justify="center"
              align="center">
              <FlexContainer>
                <div style={{fontSize: '22px'}}>Aprovado</div> 
              </FlexContainer>
              <div style={{fontSize: '22px'}}>
                {cashbackStatus.cashback}
              </div>
            </FlexContainer>
          </FlexContainer>

          <FlexContainer gap="10px">
            <Wallet src="https://static.meucupom.com/media/devolve/DEVOLVE-01.png" alt=""  />
            <FlexContainer
              direction="column"
              justify="center"
              align="center">
              <div style={{fontSize: '22px'}}>Pago</div>
              <div style={{fontSize: '22px'}}>
                {cashbackStatus.paid}
              </div>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </FlexContainer>
      <FlexContainer
      justify="space-between"
      align="center"
      style={{ width: '100%', maxWidth: '870px', borderBottom: '1px solid #000', paddingBottom: '8px', marginBottom: '0' }}
      >
        <h2 style={{ margin: 0}}>Suas compras</h2>
        <span style={{ fontSize: '14px' }}>
          Não vê sua compra aqui?{' '}
          <a href="#" onClick={(e) => { e.preventDefault(); setOpenModal(true); }}>
            Fale conosco
          </a>
        </span>
      </FlexContainer>
      <FlexContainer direction="column" justify="center" align="center" style={{marginTop: '0'}}>
        <TableDevolve cashbacks={cashbacks}/>
        {/* {cashbacks.map((cashback) => {
            return (
              <div key={cashback.id} style={{display: "flex"}}>
                <p>{cashback.id} </p>
                <p>Valor da compra: {cashback.saleValue} </p>
                <p>Cashback: {cashback.value} </p>
                <p>Status: {cashback.status} </p>
                
              </div>
            );
        })}    */}
      <FeedbackModal open={openModal} onClose={() => setOpenModal(false)} />
      </FlexContainer>
    
      
    </FlexContainer>
  )
}

export default DevolveContainer